export default "__VITE_ASSET__BnZE8QDq__"